import React from 'react';

import ShadowBox from '@core/components/shadowbox/ShadowBox';
import ActionButton from '@core/components/actionbutton/ActionButton';
import BentoBox from 'components/pages/plans/payment/subscriptionpaymentstepper/steps/bentobox/BentoBox';
import SubscriptionDiscount from 'components/common/subscriptiondiscount/SubscriptionDiscount';

import TickIcon from 'assets/icons/tick.svg';
import RadioSelectedIcon from '@core/assets/icons/radio-selected.svg';
import RadioDeselectedIcon from '@core/assets/icons/radio-deselected.svg';
import NotificationIcon from 'assets/icons/notification-icon.svg';

import classes from './step2Pro.module.scss';

const Step2Pro = ({
    data,
    period,
    setPeriod,
    hasDiscount,
    setHasDiscount,
    discountErrorMsg,
    setDiscountErrorMsg,
    setDiscountCode,
    discountCode,
    refetch,
    setCurrentStep,
    planType,
    setPlanType
}) => {
    const planKeys = {
        plus: { Monthly: 'monthly', Annual: 'yearly' },
        pro: { Monthly: 'pro_monthly', Annual: 'pro_yearly' },
    };
    const selectedPlanKey = planKeys[planType]?.[period];
    return (
        <div className={classes.wrapper}>
            <div className='row'>
                <div className='col-md-7 col-12'>
                    <ShadowBox>
                        {data.available_trial_days > 0 && (
                            <div className={classes['trial-data']}>
                                <div className='d-flex align-items-center gap-2'>
                                    <TickIcon /> <h4>{data.available_trial_days}-day Free Trial, cancel any time.</h4>
                                </div>
                                <div className='d-flex align-items-center gap-2'>
                                    <TickIcon /> <h4>We’ll remind you before your trial ends.</h4>
                                </div>
                            </div>
                        )}
                        {(data.available_trial_days === 0 && data.trial_available) && (
                            <div className={`${classes['discount-message']} d-flex align-items-center gap-2`}>
                                <NotificationIcon /> <h4>You can proceed with your discounted plan or remove the code to access the free trial instead.</h4>
                            </div>
                        )}

                        <div className={classes['period-cart']} onClick={() => { setPeriod('Annual'); setPlanType('plus'); }}>
                            <div className='d-flex flex-wrap align-items-center justify-content-between w-100'>
                                <div>
                                    {(period === 'Annual' && planType === 'plus') ? <RadioSelectedIcon /> : <RadioDeselectedIcon />}
                                    <span className={classes['period-name']}>
                                        <strong> Plus </strong>Annual
                                    </span>
                                </div>
                                <div>
                                    <div>
                                        {data.yearly.discounted_price && (
                                            <span className={classes['real-price']}>
                                                <sup className={classes.time}>{data.yearly.currency.symbol}</sup>
                                                {data.yearly.price}
                                            </span>
                                        )}
                                        {data.yearly.saving && (
                                            <span className={classes['save']}>
                                                Save {data.yearly.currency.symbol} {data.yearly.saving}
                                            </span>
                                        )}
                                    </div>
                                    <div className={classes['price']}>
                                        {data.yearly.discounted_price ? (
                                            <span>
                                                <sup className={classes.time}>{data.yearly.currency.symbol} </sup>
                                                {data.yearly.discounted_price}
                                                <span className={classes.time}>/mo</span>
                                            </span>
                                        ) : (
                                            <span>
                                                <sup className={classes.time}>{data.yearly.currency.symbol} </sup>
                                                {data.yearly.price} <span className={classes.time}>/mo</span>
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <span className={classes['popular']}>
                                    Most Popular
                                </span>
                            </div>
                        </div>
                        <div className={classes['period-cart']} onClick={() => { setPeriod('Monthly'); setPlanType('plus'); }}>
                            <div className='d-flex flex-wrap align-items-center justify-content-between w-100'>
                                <div>
                                    {(period === 'Monthly' && planType === 'plus') ? <RadioSelectedIcon /> : <RadioDeselectedIcon />}
                                    <span className={classes['period-name']}>
                                        <strong>Plus</strong> Monthly
                                    </span>
                                </div>
                                 <div>
                                    <div className='text-end'>
                                        {data.monthly.discounted_price && (
                                            <span className={classes['real-price']}>
                                                <sup className={classes.time}>{data.monthly.currency.symbol}</sup>
                                                {data.monthly.price}
                                            </span>
                                        )}
                                        {data.monthly.saving && (
                                            <span className={classes['save']}>
                                                Save {data.monthly.currency.symbol} {data.monthly.saving}
                                            </span>
                                        )}
                                    </div>
                                    <div className={classes['price']}>
                                        {data.monthly.discounted_price ? (
                                            <span>
                                                <sup className={classes.time}>{data.monthly.currency.symbol} </sup>
                                                {data.monthly.discounted_price}
                                                <span className={classes.time}>/mo</span>
                                            </span>
                                        ) : (
                                            <span>
                                                <sup className={classes.time}>{data.monthly.currency.symbol} </sup>
                                                {data.monthly.price} <span className={classes.time}>/mo</span>
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={classes['period-cart']} onClick={() => { setPeriod('Annual'); setPlanType('pro'); }}>
                            <div className='d-flex flex-wrap align-items-center justify-content-between w-100'>
                                <div>
                                    {(period === 'Annual' && planType === 'pro') ? <RadioSelectedIcon /> : <RadioDeselectedIcon />}
                                    <span className={classes['period-name-pro']}>
                                        <strong>Pro</strong> Annual
                                    </span>
                                </div>
                                <div>
                                    <div>
                                        {data.pro_yearly.discounted_price && (
                                            <span className={classes['real-price']}>
                                                <sup className={classes.time}>{data.pro_yearly.currency.symbol}</sup>
                                                {data.pro_yearly.price}
                                            </span>
                                        )}
                                        {data.pro_yearly.saving && (
                                            <span className={classes['save']}>
                                                Save {data.pro_yearly.currency.symbol} {data.pro_yearly.saving}
                                            </span>
                                        )}
                                    </div>
                                    <div className={classes['price']}>
                                        {data.pro_yearly.discounted_price ? (
                                            <span>
                                                <sup className={classes.time}>{data.pro_yearly.currency.symbol} </sup>
                                                {data.pro_yearly.discounted_price}
                                                <span className={classes.time}>/mo</span>
                                            </span>
                                        ) : (
                                            <span>
                                                <sup className={classes.time}>{data.pro_yearly.currency.symbol} </sup>
                                                {data.pro_yearly.price} <span className={classes.time}>/mo</span>
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={classes['period-cart']} onClick={() => { setPeriod('Monthly'); setPlanType('pro'); }}>
                            <div className='d-flex flex-wrap align-items-center justify-content-between w-100'>
                                <div>
                                    {(period === 'Monthly' && planType === 'pro') ? <RadioSelectedIcon /> : <RadioDeselectedIcon />}
                                    <span className={classes['period-name-pro']}>
                                        <strong>Pro</strong> Monthly
                                    </span>
                                </div>
                                 <div>
                                    <div className='text-end'>
                                        {data.pro_monthly.discounted_price && (
                                            <span className={classes['real-price']}>
                                                <sup className={classes.time}>{data.pro_monthly.currency.symbol}</sup>
                                                {data.pro_monthly.price}
                                            </span>
                                        )}
                                        {data.pro_monthly.saving && (
                                            <span className={classes['save']}>
                                                Save {data.pro_monthly.currency.symbol} {data.pro_monthly.saving}
                                            </span>
                                        )}
                                    </div>
                                    <div className={classes['price']}>
                                        {data.pro_monthly.discounted_price ? (
                                            <span>
                                                <sup className={classes.time}>{data.pro_monthly.currency.symbol} </sup>
                                                {data.pro_monthly.discounted_price}
                                                <span className={classes.time}>/mo</span>
                                            </span>
                                        ) : (
                                            <span>
                                                <sup className={classes.time}>{data.pro_monthly.currency.symbol} </sup>
                                                {data.pro_monthly.price} <span className={classes.time}>/mo</span>
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className={`${classes['discount']} d-flex flex-column`}>
                            <SubscriptionDiscount
                                data={data}
                                selectedPlanKey={selectedPlanKey}
                                hasDiscount={hasDiscount}
                                setHasDiscount={setHasDiscount}
                                discountErrorMsg={discountErrorMsg}
                                discountCode={discountCode}
                                setDiscountCode={setDiscountCode}
                                refetch={refetch}
                            />
                        </div>
                    </ShadowBox>
                    <ActionButton kind='secondary_main' onClick={() => setCurrentStep(3)} >Next</ActionButton>
                </div>
                <div className='col-md-5 col-12 d-md-block d-none'>
                    <div className={classes['bento-wrapper']}>
                        <ShadowBox>
                            <BentoBox />
                        </ShadowBox>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Step2Pro;